import { cn } from '../lib/utils.ts';
import sowGlyph from '../static/sow-glyph.svg';
import boarGlyph from '../static/boar-glyph.svg';

/** Which parent the drawing stands for - the sow (with her piglets) or the boar. */
export type ParentGlyphSide = 'Mother' | 'Father';

const GLYPH_SRC: Record<ParentGlyphSide, string> = {
  Mother: sowGlyph,
  Father: boarGlyph
};

interface ParentGlyphProps {
  side: ParentGlyphSide;
  /** Size and any spacing; the drawings are roughly 2:1, so pick a width twice the height. */
  className?: string;
  /** Any CSS colour. The glyph takes it whole, since it is a silhouette. */
  color?: string;
}

/**
 * The sow and boar silhouettes, drawn in one colour.
 *
 * They are painted as a CSS mask rather than dropped in with an `<img>`: the files are plain black
 * artwork, and an image cannot be recoloured, so the column would lose the tint that tells the two
 * lines apart at a glance.
 */
const ParentGlyph = ({ side, className, color }: ParentGlyphProps) => {
  // Quoted: under 4kB Vite inlines an asset as a `data:` URI, which an unquoted url() cannot hold -
  // the mask then resolves to nothing and the span paints as a solid block.
  const mask = `url("${GLYPH_SRC[side]}") center / contain no-repeat`;

  return (
    <span
      aria-hidden
      className={cn('inline-block shrink-0 bg-current', className)}
      style={{ mask, WebkitMask: mask, color }}
    />
  );
};

export default ParentGlyph;
